// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.accounting.VoidPatientRefundRequest */
/* istanbul ignore next */
@GandalfModel
export class VoidPatientRefundRequest extends GandalfModelBase {

	@GandalfLabel('Patient')
	@GandalfValidator({ notNull: { message: 'Patient is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientId!: number;

	@GandalfLabel('Reason')
	@GandalfValidator({ sizeString: { message: 'Reason cannot be longer than 235 characters', minLength: 0, maxLength: 235 } })
	@GandalfProperty({ designType: String })
	reason!: string | null;

	@GandalfLabel('Refund')
	@GandalfValidator({ notNull: { message: 'Refund is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	refundId!: number;

}
